import classNames from 'classnames';
import React from 'react';
import styles from "Styles/TextInput.module.css";
import ErrorMessage from './ErrorMessage';

const TextInput = React.forwardRef(({className,errorText="" ,...props}, ref) => {
  const textInputWrapperClassNames = classNames(
    styles.textInputWrapper
  );
  const textInputClassNames = classNames(
    className,
    styles.textInput,
  );
  
  return (
    <div className={textInputWrapperClassNames}>
      <input ref={ref} className={textInputClassNames} {...props}/>
			
      {errorText.length > 0 && (
				<ErrorMessage text={errorText}/>
      )}
    </div>
  )
});

export default TextInput;